<script lang="ts">
  // A labelled text input with an optional inline error. `value` is bindable.
  import { Input } from "@price-check/ui";

  let {
    label,
    value = $bindable(""),
    type = "text",
    placeholder = "",
    autocomplete,
    // The form-control `name` — forwarded to the inner <Input>. The browser keys
    // its "previously typed values" suggestions on `name`, so an email field
    // needs name="username" for native autofill to remember + offer past emails.
    name,
    id,
    error = "",
    disabled = false,
  }: {
    label?: string;
    value?: string;
    type?: "text" | "email" | "password";
    placeholder?: string;
    autocomplete?: string;
    name?: string;
    id?: string;
    error?: string;
    disabled?: boolean;
  } = $props();
</script>

<div class="flex flex-col gap-1.5">
  {#if label}<label class="text-sm font-semibold text-ink" for={id}>{label}</label>{/if}
  <Input
    {id}
    {type}
    {name}
    {placeholder}
    autocomplete={autocomplete as AutoFill}
    {disabled}
    bind:value
    class={error ? "border-danger-border focus:border-danger-border" : undefined}
  />
  {#if error}<p class="m-0 text-xs text-danger">{error}</p>{/if}
</div>
